import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import "./index.css";
import "./App.css";
import HomePage from "./components/HomePage";
import DataView from "./components/DataView";
import MacroClimateView from "./components/MacroClimateView";

function App() {
  return (
    <div className="w-full m-0 p-0 overflow-hidden">
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/data" element={<DataView />} />
          <Route path="/macroclimate" element={<MacroClimateView />} />
          <Route
            path="/about"
            element={
              <div className="placeholder-page">
                <h1>About Page</h1>
                <p>Coming soon...</p>
              </div>
            }
          />
          <Route
            path="/contact"
            element={
              <div className="placeholder-page">
                <h1>Contact Page</h1>
                <p>Coming soon...</p>
              </div>
            }
          />
        </Routes>
      </Router>
      <Analytics />
    </div>
  );
}

export default App;
